export default __webpack_public_path__ + "static/media/barlow-testi.33249c46.jpeg";